/**
 * Cálculos derivados. Se aplican en lectura, nunca se almacenan: así un
 * cambio en los inputs no deja el derivado desincronizado.
 *
 * Todos devuelven null cuando falta un input, para que la UI muestre
 * "sin dato" en lugar de un cero engañoso.
 */

export interface ActivationGap {
  contratados: number
  instalados: number
  brecha: number
  pctActivado: number
}

/** Empleados digitales contratados vs efectivamente instalados. */
export function activationGap(input: {
  contratados: number
  instalados: number
}): ActivationGap {
  const { contratados, instalados } = input
  if (contratados <= 0) {
    return { contratados, instalados, brecha: 0, pctActivado: 0 }
  }
  const brecha = Math.max(0, contratados - instalados)
  const pctActivado = Math.min(100, (instalados / contratados) * 100)
  return { contratados, instalados, brecha, pctActivado }
}

export function growthMoMPct(input: {
  actual: number
  anterior: number | null
}): number | null {
  const { actual, anterior } = input
  if (anterior === null || anterior === 0) return null
  return ((actual - anterior) / anterior) * 100
}

export function netNewMrr(input: {
  nuevoMrr: number
  expansionMrr: number
  churnedMrr: number
}): number {
  return input.nuevoMrr + input.expansionMrr - input.churnedMrr
}

/** 1 - (1 - churn_mensual)^12. Entrada y salida en porcentaje. */
export function annualChurnFromMonthly(monthlyPct: number | null): number | null {
  if (monthlyPct === null) return null
  return (1 - Math.pow(1 - monthlyPct / 100, 12)) * 100
}

/** ARPU / churn. Churn 0 daría infinito, que no es accionable: null. */
export function ltv(input: {
  arpu: number | null
  churnRatePct: number | null
}): number | null {
  const { arpu, churnRatePct } = input
  if (arpu === null || churnRatePct === null || churnRatePct === 0) return null
  return arpu / (churnRatePct / 100)
}

export function ltvCacRatio(input: {
  ltv: number | null
  cac: number | null
}): number | null {
  const { ltv: l, cac } = input
  if (l === null || cac === null || cac === 0) return null
  return l / cac
}

export function paybackMonths(input: {
  cac: number | null
  mrrPorCliente: number | null
}): number | null {
  const { cac, mrrPorCliente } = input
  if (cac === null || mrrPorCliente === null || mrrPorCliente === 0) return null
  return cac / mrrPorCliente
}
